/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_TitleInputs */

const en_filter_title = /** @type {(inputs: Filter_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter & sort`)
};

const de_filter_title = /** @type {(inputs: Filter_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtern & sortieren`)
};

/**
* | output |
* | --- |
* | "Filter & sort" |
*
* @param {Filter_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_title = /** @type {((inputs?: Filter_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_title(inputs)
	return en_filter_title(inputs)
});